import React from "react"
import { lightBlack, titlesGray } from "../../../../../../themes/variables"
import { Product, ProductVariant } from "../../../../../../types/product"
import { CustomBox } from "../../../../../../ui/spacings/CustomBox"
import { BasketItem } from "../../../../state/checkoutTypes"
import { CloseButton } from "../../../../../../ui/atoms/IconButton/buttons/close"
import { ProductVariantDropdown } from "../../../../../product/components/ProductVariantDropdown"
import ProductQuantityChange from "../../../../../product/components/ProductQuantityChange"
import ProductLineItem from "../../../../../../ui/organisms/Product/ProductLineItem"
import { getFidelityPointsLabel } from "../../../../../../utils/fidelity"
import Typography from "../../../../../../ui/atoms/Typography"
import CustomCheckbox from "../../../../../../ui/atoms/CustomCheckbox"
import { useLabels } from "../../../../../contents/hooks"
import { GiftIcon } from "../../../../../../ui/icons/GiftIcon"

interface Props {
  giftBoxEnabled?: boolean
  item: BasketItem
  onProductRemove: () => void
  onProductMoveToWishlist: () => void
  onProductVariantChange: (newVariant: ProductVariant) => void
  onProductQuantityChange: (newQuantity: number) => void
  onProductGiftToggle: (newValue: boolean) => void
}

const BasketItemListElement = ({
  giftBoxEnabled,
  item,
  onProductRemove,
  onProductVariantChange,
  onProductQuantityChange,
  onProductGiftToggle,
}: Props) => {
  const { getLabel } = useLabels()
  return (
    <ProductLineItem
      product={item.product as Product}
      variant={item.variant as ProductVariant}
      pricing={{
        originalPrice: item.order.total.originalPrice,
        discountedPrice: item.order.total.discountedPrice,
        compareAtPrice: item.order.total.compareAtPrice,
        discountPercent: item.order.total.discountPercent,
        extraDiscountPercent: item.order.total.extraDiscountPercent,
      }}
      topControls={
        <>
          {/* <CustomIconButton
            onClick={onProductMoveToWishlist}
            icon={<RiHeartAddLine color={lightBlack} size={20} />}
          /> */}
          <CloseButton color={lightBlack} onClick={onProductRemove} size={20} />
        </>
      }
      bottomControls={
        <div className="flex items-center">
          {giftBoxEnabled && (
            <div className="mr-2">
              <CustomCheckbox
                value={item.order.gift}
                onChange={onProductGiftToggle}
              >
                <GiftIcon
                  style={{
                    width: 30,
                  }}
                />
              </CustomCheckbox>
            </div>
          )}
          <Typography colorValue={titlesGray}>
            {getFidelityPointsLabel(
              item.order.total.discountedPrice ??
                item.order.total.originalPrice,
              getLabel
            )}
          </Typography>
        </div>
      }
    >
      <CustomBox flex="row" justifyContent="space-between" mt={1}>
        <CustomBox flex="row" fullWidth>
          <CustomBox minWidth="80px">
            <ProductQuantityChange
              quantity={item.order.quantity}
              maxQuantity={item.order.maxQuantity}
              onQuantityChange={onProductQuantityChange}
            />
          </CustomBox>
          <CustomBox pl={1} flexFill>
            <ProductVariantDropdown
              variants={
                item.product?.variants.filter((x) => x.inventory?.available) ??
                []
              }
              selectedVariant={item.variant as ProductVariant}
              onVariantSelect={onProductVariantChange}
            />
          </CustomBox>
        </CustomBox>
      </CustomBox>
    </ProductLineItem>
  )
}

export default BasketItemListElement
